module.exports = __webpack_public_path__ + "img/衢州市.d69ef08e.png";